export const theme = {
    colors: {
      primaryTextColor: '#E8E8E0',
      secondaryTextColor: '#191919',
      thirdTextColor: '#75756F',
      primaryNoteItemColor: '#2AA49F',
      secondaryNoteItemColor: '#4D4B4B',
      accentHoverColor: '#8C6000',
      pageBackground: '#CCCCCC',
      primaryAppBackground: '#111111',
      secondaryAppBackground: '',
      deleteColor: '#F04422',
      borderButtonColor: '#4D4B4B',
      primaryBackgroundColor: '#191919',
      primaryBackgroundButton: '#FEFEFEF5',
    },
    space: [0, 2, 4, 8, 16, 32, 64, 128, 256],
    fonts: {
      body: 'system-ui, sans-serif',
      heading: 'system-ui, sans-serif',
      monospace: 'Menlo, monospace',
    },
    fontSizes: {
      title: '25px',
      xs: '12px',
      s: '14px',
      m: '16px',
      l: '32px',
      xl: '64px',
    },
    fontWeights: {
      thin: 100,  
      normal: 400,
      medium: 600,
      bold: 700,
    },
    lineHeights: {
      body: 1.5,
      heading: 1.125,
    },
    borders: {
      none: 'none',
      normal: '1px solid',
    },
    radii: {
      none: '0',
      sm: '4px',
      md: '8px',
      lg: '16px',
      round: '50%',
    },
  
    layout: {
      loptop: '1024px',
      tablet: '768px',
      mobile: '425px',
      mediumMobile: '375px',
      smallMobile: '320px',
    },

    containerWidth: {
        lg: '75%',
        md: '86%',
        ms: '90%',
    }
  };